import { Pipe, PipeTransform } from '@angular/core';
import { Hex } from '@t-llevo/util';

@Pipe({
  name: 'travelStatusColor',
  standalone: true,
})
export class TravelStatusColorPipe implements PipeTransform {
  transform(status: string): Hex {
    if (status.toLowerCase() === 'cancelled') {
      return '#9f1239';
    } else if (status.toLowerCase() === 'collected') {
      return '#EAB308';
    } else if (status.toLowerCase() === 'executed') {
      return '#D97706';
    } else if (status.toLowerCase() === 'finalized') {
      return '#166534';
    } else if (status.toLowerCase() === 'requested') {
      return '#155E75';
    }

    return '#FFFFFF';
  }
}
